/**
 * Reads the `:uid` URL param and wraps children in a <TargetUidProvider>.
 * Used under the `/admin/users/:uid/settings/*` route tree so the same
 * settings components and hooks work against the target user.
 */
import { Navigate, useParams } from 'react-router-dom';
import { TargetUidProvider } from './TargetUidContext';

export function AdminTargetGate({ children }: { children: React.ReactNode }) {
  const { uid } = useParams<{ uid: string }>();
  if (!uid) return <Navigate to="/admin/users" replace />;
  return <TargetUidProvider uid={uid}>{children}</TargetUidProvider>;
}
